// Definindo tipos para os itens de ordenação
interface OrderByItem {
  label: string
  value: OrderByValue
}

type OrderByValue = 'minValue' | 'maxValue'

export const OrderByEnum: OrderByItem[] = [
  { label: 'Menor valor', value: 'minValue' },
  { label: 'Maior valor', value: 'maxValue' }
]

// Definindo tipos para a ordenação de grupos
interface OrderGroupsByItem {
  label: string
  value: OrderGroupsByValue
}

type OrderGroupsByValue = 'cdGrupo' | 'menorLanceContemplado' | 'minValue' | 'maxValue'

export const orderGroupsByEnum: OrderGroupsByItem[] = [
  { label: 'Código do grupo', value: 'cdGrupo' },
  { label: 'Menor lance contemplado', value: 'menorLanceContemplado' },
  { label: 'Menor valor', value: 'minValue' },
  { label: 'Maior valor', value: 'maxValue' }
]

export type OrderGroupsByEnum = OrderGroupsByValue

// Definindo tipos para a ordenação de confirmação de contemplação
interface OrderConfirmationItem {
  label: string
  value: OrderConfirmationValue
}

type OrderConfirmationValue = 'proposta' | 'nomeProduto' | 'dataContemplacao' | 'valorBem'

export const orderConfirmationEnum: OrderConfirmationItem[] = [
  { label: 'Proposta', value: 'proposta' },
  { label: 'Nome do Produto', value: 'nomeProduto' },
  { label: 'Data de Contemplação', value: 'dataContemplacao' },
  { label: 'Valor do Bem', value: 'valorBem' }
]

export type OrderConfirmationEnum = OrderConfirmationValue

// Definindo tipos para a ordenação de gestão
interface OrderManagementItem {
  label: string
  value: OrderManagementValue
}

type OrderManagementValue = 'cd_inscricao_nacional' | 'proposal' | 'newest' | 'oldest'

export const OrderManagementEnum: OrderManagementItem[] = [
  { label: 'CPF/CNPJ', value: 'cd_inscricao_nacional' },
  { label: 'Proposta', value: 'proposal' },
  { label: 'Venda recente', value: 'newest' },
  { label: 'Venda antiga', value: 'oldest' }
]

// Definindo tipos para o status do relatório de propostas
export type ProposalStatusReportSelect = 'Parcelas pagas' | 'Parcelas não pagas'

export const PROPOSAL_STATUS_REPORT_SELECT: ProposalStatusReportSelect[] = [
  'Parcelas pagas',
  'Parcelas não pagas'
]

// Definindo tipos para o status do relatório de pagamentos
export type PaymentStatusReportSelect =
  | 'Propostas Alocadas'
  | 'Parcelas Não Alocadas'
  | 'Propostas Canceladas'
  | 'Propostas C/ Documentos Pendentes'
  | 'Propostas Vendidas para Grupo em Andamento'
  | 'Propostas Vendidas para Grupo em Formação'

export const PAYMENT_STATUS_REPORT_SELECT: PaymentStatusReportSelect[] = [
  'Propostas Alocadas',
  'Parcelas Não Alocadas',
  'Propostas Canceladas',
  'Propostas C/ Documentos Pendentes',
  'Propostas Vendidas para Grupo em Andamento',
  'Propostas Vendidas para Grupo em Formação'
]

// Definindo tipos para o status de documentos
interface FilterDocumentStatusItem {
  label: string
  value: FilterDocumentStatusValue
}

type FilterDocumentStatusValue = 'A' | 'R' | 'E' | 'P' | 'T'

export const FILTER_DOCUMENT_STATUS_SELECT: FilterDocumentStatusItem[] = [
  { value: 'T', label: 'Todos' },
  { value: 'A', label: 'Aprovado' },
  { value: 'R', label: 'Reprovado' },
  { value: 'E', label: 'Em análise' },
  { value: 'P', label: 'Pendente' }
]

// Definindo tipos para o status de flex
interface ListFlexStatusItem {
  label: string
  value: ListFlexStatusValue
}

type ListFlexStatusValue = 'L'

export const LIST_FLEX_STATUS_SELECT: ListFlexStatusItem[] = [
  { value: 'L', label: 'Flexibilização' }
]

// Definindo tipos para o status de documentos (outra lista)
interface ListDocumentStatusItem {
  label: string
  value: ListDocumentStatusValue
}

type ListDocumentStatusValue = 'P' | 'A' | 'R' | 'E'

export const LIST_DOCUMENT_STATUS_SELECT: ListDocumentStatusItem[] = [
  { value: 'P', label: 'Pendente' },
  { value: 'A', label: 'Aprovado' },
  { value: 'R', label: 'Reprovado' },
  { value: 'E', label: 'Em análise' }
]

// Definindo tipos para o status do card publicitário
interface ListPubliCardStatusItem {
  label: string
  value: ListPubliCardStatusValue
}

type ListPubliCardStatusValue = 'T' | 'A' | 'I'

export const LIST_PUBLI_CARD_STATUS_SELECT: ListPubliCardStatusItem[] = [
  { value: 'T', label: 'Todos' },
  { value: 'A', label: 'Ativo' },
  { value: 'I', label: 'Inativo' }
]

// Definindo tipos para o menu do card publicitário
interface ListPubliCardMenuItem {
  label: string
  value: ListPubliCardMenuValue
}

type ListPubliCardMenuValue = 'SI' | 'GV' | 'MA' | 'DO' | 'FL'

export const LIST_PUBLI_CARD_MENU_SELECT: ListPubliCardMenuItem[] = [
  { value: 'SI', label: 'Simulação' },
  { value: 'GV', label: 'Gestão de vendas' },
  { value: 'MA', label: 'Material de apoio' },
  { value: 'DO', label: 'Documentação' },
  { value: 'FL', label: 'Flexibilização' }
]

// Definindo tipos para a ordenação de cards publicitários
interface OrderPubliCardItem {
  label: string
  value: OrderPubliCardValue
}

type OrderPubliCardValue = 'newest' | 'oldest'

export const OrderPubliCardEnum: OrderPubliCardItem[] = [
  { label: 'Data recente', value: 'newest' },
  { label: 'Data antiga', value: 'oldest' }
]

export const LIST_USER_CARD_STATUS_SELECT = [
  { value: 'N', label: 'Ativo' },
  { value: 'S', label: 'Inativo' }
]

export const OrderUserCardEnum = [
  { label: 'Nome', value: 'nm_pessoa' },
  { label: 'Documento', value: 'cd_inscricao_nacional' },
  { label: 'Código', value: 'cd_usuario' }
]

// Definindo tipos para a ordenação de utilização de carta de crédito
interface OrderUtilizacaoCartaItem {
  label: string
  value: OrderUtilizacaoCartaValue
}

type OrderUtilizacaoCartaValue =
  | 'codigoGrupo'
  | 'numeroCota'
  | 'dataContemplacao'
  | 'valorCartaCredito'

export const orderUtilizacaoCartaEnum: OrderUtilizacaoCartaItem[] = [
  { label: 'Grupo', value: 'codigoGrupo' },
  { label: 'Cota', value: 'numeroCota' },
  { label: 'Data de Contemplação', value: 'dataContemplacao' },
  { label: 'Valor da Carta', value: 'valorCartaCredito' }
]

export type OrderUtilizacaoCartaEnum = OrderUtilizacaoCartaValue
